import { IAutoPolicy } from '../../../interfaces';

export function getRegionCodeFromPolicy(p: IAutoPolicy) {
  return p.details.region_config_code || p.rating_address.region.code;
}
